/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'GoalPanel.header.title': 'Meta',
  'goal-panel.generic-error.description': 'Verifique a conexão com a Internet e tente outra vez.',
  'goal-panel.generic-error.title': 'Algo deu errado',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'Mostrar mais campos',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': 'Mostrar menos',
  'goal-panel.goal-panel-tabs.about-tab-title': 'Sobre',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'Projetos',
  'goal-panel.goal-panel-tabs.updates-tab-title': 'Atualizações',
  'goal-panel.goal-title.edit-button-label': 'Editar título da meta',
  'goal-panel.goal-title.update-error-description': 'Não foi possível atualizar o conteúdo de {goalName}',
  'goal-panel.goal-title.update-error-title': 'Algo deu errado',
  'goal-panel.goal-title.validation-message': 'Dê um título para a meta',
};
